import { v4 as uuidv4 } from 'uuid'

import { preserveNullAndZeroValues, toNumber } from '../../helpers'
import { formatStakeholdersListToBE } from '../../formatters/stakeholdersListTransformers'

import { COUNTRY_ID, TITLE, TOTAL_ACTIVITY_HOURS, TOTAL_INVESTMENT } from '../../fields'
import { ASSUMPTION_NAME, ASSUMPTIONS } from '../../assumptionsFields'
import { STAKEHOLDERS_LIST } from '../../stakeholdersFields'
import { REPORTING_YEAR } from '../../../YearFilter/fields'

export const transformValuesToBE = (values, selectedPartnership) => {
  const filledAssumptions = values[ASSUMPTIONS].filter(assumption => assumption[ASSUMPTION_NAME])

  // Get rightsholder name from selected partnership and replace spaces with underscores
  const rightsHolderName = (selectedPartnership?.rights_holder_name || '').replace(/\s+/g, '_')

  // Generate unique_id as {rightsholder name}_{uuid}
  const uniqueId = `${rightsHolderName}_${uuidv4()}`

  // Get current year for reporting_year
  const reportingYear = new Date().getFullYear()

  return {
    [TITLE]: values[TITLE],
    payload: {
      // Auto-filled fields (not from UI)
      sector_id: 'AAMA',
      [REPORTING_YEAR]: reportingYear,
      unique_id: uniqueId,
      // general inputs section
      [COUNTRY_ID]: values[COUNTRY_ID],
      [TOTAL_INVESTMENT]: toNumber(values[TOTAL_INVESTMENT]),
      [TOTAL_ACTIVITY_HOURS]: toNumber(values[TOTAL_ACTIVITY_HOURS]),
      // assumptions section
      [ASSUMPTIONS]: filledAssumptions.map(assumption => preserveNullAndZeroValues(assumption)),
      // stakeholders section
      [STAKEHOLDERS_LIST]: formatStakeholdersListToBE(values)
    }
  }
}
